import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { DataService } from '../data.service';
import { NaploService } from './naplo.service';

import { utvonalJoga } from './naplo-menu';

/**
 *  A NAPLO oldalainak őre – két szabály:
 *
 *   1. JOG. Az oldalt csak az nyithatja meg, akinek a jogkörszerkesztőben joga van rá
 *      (Jogosultságok → NAPLO). A menü eddig is ez alapján rajzolódott, de közvetlen címmel
 *      bármelyik oldal megnyílt. (A kiszolgáló a saját kapujával ugyanezt ellenőrzi – az őr
 *      a felhasználónak szól: nem tölt be egy félig működő, hibát dobáló oldalt.)
 *   2. ÜGYFÉL. Amíg nincs kiválasztott ügyfél, csak az ügyfélválasztó nyílik meg: minden
 *      más oldal egy ügyfél adatával dolgozik, ügyfél nélkül üres vagy félrevezető lenne.
 *
 *  Az ügyfélválasztó mindenkinek nyitva áll, akinek van NAPLO-joga: ügyfél nélkül semmi
 *  sem működik. Az ügyfél felvétele/módosítása az Ügyfelek képernyő joga (kiszolgáló dönti).
 */
@Injectable({ providedIn: 'root' })
export class NaploOldalGuard implements CanActivateChild {
  constructor(private data: DataService, private naplo: NaploService,
              private router: Router, private toast: ToastController) {}

  async canActivateChild(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const szakasz = route.routeConfig?.path || '';
    if (!szakasz || szakasz === 'ugyfelek') return true;

    // 1) jog – csak NAPLO-módban: a hozzáférés-lista az aktuális alrendszeré. A főmenü
    //    mindenkié, akinek van NAPLO-joga (a csempéit a jogok szerint szűri).
    if (szakasz !== 'fomenu' && (await this.data.getFromStorage('currentMode')) === 'NAPLO') {
      const jog = await this.data.hozzaferesek();
      // Az útvonal és a nézet együtt dönti el, melyik képernyő joga kell (naplo-menu.ts).
      const kepernyok = utvonalJoga(szakasz, route.queryParams || {});
      if (!kepernyok.some((k) => jog.szabad(k))) {
        this.jelez('Ehhez az oldalhoz nincs jogosultságod. A jogot a Jogosultságok szerkesztőben lehet megadni.');
        return this.router.createUrlTree(['/naplo/ugyfelek']);
      }
    }

    // 2) kötelező ügyfélválasztás
    const aktiv = this.naplo.aktiv.ugyfelId ? this.naplo.aktiv : await this.naplo.init();
    if (!aktiv.ugyfelId) {
      this.jelez('Előbb válassz ügyfelet.');
      return this.router.createUrlTree(['/naplo/ugyfelek']);
    }
    return true;
  }

  private async jelez(uzenet: string) {
    try { (await this.toast.create({ message: uzenet, duration: 2600, color: 'warning' })).present(); } catch { /* nem kritikus */ }
  }
}
